const React = require('react');
const moment = require('moment');

const formatAmount = require('../shared/format_amount.js');

class Order extends React.Component {
  detailsLink = (content) => {
    return (
      <a href={this.props.order._links.web.href}>{content}</a>
    );
  };

  formattedTotal = () => {
    if (this.props.order.total) {
      return formatAmount(this.props.order.total);
    } else {
      return formatAmount(this.props.order.amount_product_subtotal);
    }
  };

  formattedCreatedAt = () => {
    return moment(this.props.order.created_at).fromNow();
  };

  orderState = () => {
    return this.props.order.actionable_status;
  };

  formattedState = () => {
    return this.orderState().replace(/_/g, ' ');
  };

  orderStateIndicatorClass = () => {
    if (this.props.negativeStates.indexOf(this.orderState()) !== -1) {
      return 'important';
    } else if (this.props.neutralStates.indexOf(this.orderState()) !== -1) {
      return '';
    } else {
      return 'success';
    }
  };

  render() {
    return (
      <li className="previous-order dark-links has-divider">
        {this.detailsLink(
          <div className="g-container">
            <div className="g-col-3">
              <img className="img-wide bd-rounded" src={this.props.order._links.photo.href} />
            </div>
            <div className="g-col-9 strong">
              <div className="g-container">
                <div className="g-col-8">
                  <div className="truncate color-gray">{this.props.order.title}</div>
                </div>
                <div className="g-col-4">
                  <div className="color-orange align-right">{this.formattedTotal()}</div>
                </div>
              </div>
              <div className="muted fine-print normal sentence-capitalization">{this.formattedCreatedAt()}</div>
              <div className={`inline-block badge tiny capitalize ${this.orderStateIndicatorClass()}`}>{this.formattedState()}</div>
            </div>
          </div>
          )}
        </li>
    );
  }
}

module.exports = Order;




// WEBPACK FOOTER //
// ./javascripts/components/previous_orders/order.jsx